import React, { useState } from "react";
import style from "./index.module.scss";
import {
    Col,
    Icon,
    Input,
    InputNumber,
    Modal,
    Row,
    Spin,
    Tooltip,
    DatePicker,
    message,
    TimePicker,
    Button
} from "antd";
import moment from "moment";
import ProjectListModal from "./components/ProjectListModal";
import { createExperiment, ExperimentInfo } from "API/navExperiment";
import { errorMessage } from "Utils/useRequest";
import { ResultMessage } from "components/ResultMessage";

interface SettingModalProps {
    visible: boolean; //显示与隐藏的状态
    onCancel: () => void; //取消
    onOk: () => void; //刷新列表
    dataDetail: ExperimentInfo | null; //具体实验项目详情
}

export default function SettingModal({
    visible,
    onCancel,
    onOk,
    dataDetail
}: SettingModalProps) {
    // const { RangePicker } = DatePicker
    const [planName, setPlanName] = useState(""); //计划名
    const [date, setDate] = useState(""); //日期
    const [beginTime, setBeginTime] = useState(""); //开始时间
    const [endTime, setEndTime] = useState(""); //结束时间
    const [error, setError] = useState({ projectTime: "" }); // 错误状态

    const [isShow, setIsShow] = useState(false); //是否展示资源列表，默认不展示
    const [loading, setLoading] = useState(false);

    const format = "HH:mm";

    async function addHandler() {
        if (!checkData() || !dataDetail) return;
        setLoading(true);

        const params = {
            planName,
            useCount: 1,
            projectName: dataDetail.projectName,
            beginTime: date + " " + beginTime,
            endTime: date + " " + endTime,
            osName: dataDetail.osName,
            installingSoftware: dataDetail.softWare,
            cloudDeskExpId: dataDetail.id,
            cloudGuid: dataDetail.cloudGuid
        };

        try {
            await createExperiment({ ...params });
            ResultMessage.success("添加成功!");
            onOk();
            onCancel();
            handleClose();
        } catch (e) {
            message.error(errorMessage(e));
        }

        setLoading(false);
    }

    // 检查数据
    function checkData(): boolean {
        const err = { projectTime: "" };

        if (
            date.trim().length === 0 ||
            beginTime.trim().length === 0 ||
            endTime.trim().length === 0
        ) {
            err.projectTime = "实验时间必填，请选择实验时间";
            setError(err);
            return false;
        }

        if (
            moment(date + " " + endTime).isBefore(
                moment(date + " " + beginTime)
            )
        ) {
            err.projectTime = "开始时间大于结束时间";
            setError(err);
            return false;
        }

        if (
            moment(date + " " + endTime).isSame(moment(date + " " + beginTime))
        ) {
            err.projectTime = "开始时间等于结束时间";
            setError(err);
            return false;
        }

        setError(err);
        return true;
    }

    //关闭时清空表单
    function handleClose() {
        if (loading) return;

        onCancel();
        setPlanName("");
        setDate("");
        setBeginTime("");
        setEndTime("");
        setError({ projectTime: "" });
    }

    // //实验时间改变
    // function onProjectTimeChange(dates: any) {
    //     const start = dates.length !== 0 ? moment(dates?.[0]).format("YYYY-MM-DD HH:mm:ss") : '';
    //     const end = dates.length !== 0 ? moment(dates?.[1]).format("YYYY-MM-DD HH:mm:ss") : '';
    //     setBeginTime(start);
    //     setEndTime(end);
    // }

    //选择日期
    function onChangeDate(date: any) {
        setDate(date === null ? "" : moment(date).format("YYYY-MM-DD"));
    }

    //选择开始时间
    function onChangeBeginTime(time: any) {
        setBeginTime(time === null ? "" : moment(time).format("HH:mm:ss"));
    }

    //选择结束时间
    function onChangeEndTime(time: any) {
        setEndTime(time === null ? "" : moment(time).format("HH:mm:ss"));
    }

    const footer = (
        <div>
            <Button onClick={handleClose} disabled={loading}>
                取消
            </Button>
            <Button type="primary" onClick={addHandler} disabled={loading}>
                确定
            </Button>
        </div>
    );

    return (
        <>
            <Modal
                visible={visible}
                title="新建实验计划"
                closable={false}
                className={style.root}
                width={610}
                confirmLoading={loading}
                maskClosable={false}
                footer={footer}>
                <Spin spinning={loading}>
                    <Row>
                        <Col span={6} className={style.label}>
                            名称：
                        </Col>
                        <Col span={15} className={style.label}>
                            <Input
                                placeholder="请输入实验使用计划名称"
                                value={planName}
                                onChange={e => setPlanName(e.target.value)}
                                maxLength={500}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col span={6} className={style.label}>
                            预约人数：
                        </Col>
                        <Col span={15} className={style.label}>
                            <InputNumber min={1} max={999} value={1} disabled />
                        </Col>
                        <Col span={3}>
                            <Tooltip
                                placement="top"
                                title={"学生预约数量只能为1"}>
                                <Icon type="info-circle" />
                            </Tooltip>
                        </Col>
                    </Row>

                    <Row>
                        <Col span={6} className={style.label}>
                            <i className={style.warning}>*</i>实验项目：
                        </Col>
                        <Col span={15} className={style.label}>
                            <Input
                                maxLength={20}
                                value={dataDetail?.projectName}
                                disabled
                            />
                            <div
                                className={style.resource}
                                onClick={() => setIsShow(true)}>
                                查看资源
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col span={6} className={style.label}>
                            <i className={style.warning}>*</i>实验时间：
                        </Col>
                        <Col span={15} className={style.label}>
                            {/* <RangePicker
                                className={style.rangePicker}
                                showTime
                                format="YYYY-MM-DD HH:mm"
                                onChange={onProjectTimeChange}
                                value={!beginTime ? [null, null] : [moment(beginTime, "YYYY-MM-DD HH:mm"), moment(endTime, "YYYY-MM-DD HH:mm")]}
                            /> */}
                            <div className={style.date}>
                                <DatePicker
                                    onChange={onChangeDate}
                                    value={
                                        date ? moment(date, "YYYY-MM-DD") : null
                                    }
                                />
                                <TimePicker
                                    onChange={onChangeBeginTime}
                                    format={format}
                                    placeholder="开始时间"
                                    value={
                                        beginTime
                                            ? moment(beginTime, format)
                                            : undefined
                                    }
                                />
                                <TimePicker
                                    onChange={onChangeEndTime}
                                    format={format}
                                    placeholder="结束时间"
                                    value={
                                        endTime
                                            ? moment(endTime, format)
                                            : undefined
                                    }
                                />
                            </div>

                            {error.projectTime && (
                                <div className={style.error}>
                                    {error.projectTime}
                                </div>
                            )}
                        </Col>
                    </Row>
                </Spin>
            </Modal>

            <ProjectListModal
                isShow={isShow}
                onChange={() => setIsShow(false)}
                projectName={dataDetail?.projectName}
                cloudGuid={dataDetail?.cloudGuid}
                nameLabel={dataDetail?.nameLabel}
            />
        </>
    );
}
